import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	createLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	createLabel: {
		id: 'issue-table-inline-issue-create.inline-create-trigger.create-label',
		defaultMessage: 'Create',
		description: 'Label of the button to create an issue.',
	},
});
export default messages;
